/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChannelAdminDto } from '../models/ChannelAdminDto';
import type { ChannelStatus } from '../models/ChannelStatus';
import type { ChannelType } from '../models/ChannelType';
import type { GenericZohoValuesAdminDto } from '../models/GenericZohoValuesAdminDto';
import type { GetAllChannelsAdminResponse } from '../models/GetAllChannelsAdminResponse';
import type { GetChannelOrderRegionsResponseAdmin } from '../models/GetChannelOrderRegionsResponseAdmin';
import type { GetChannelRegionsAdminResponse } from '../models/GetChannelRegionsAdminResponse';
import type { GetChannelsClientResponse } from '../models/GetChannelsClientResponse';
import type { GetChannelServiceZohoBooksAccountsAdminResponse } from '../models/GetChannelServiceZohoBooksAccountsAdminResponse';
import type { GetLayoutChannelsDtoResponseAdmin } from '../models/GetLayoutChannelsDtoResponseAdmin';
import type { Language } from '../models/Language';
import type { Pagination1OfChannelListedAdminDto } from '../models/Pagination1OfChannelListedAdminDto';
import type { PostChannelRequestAdmin } from '../models/PostChannelRequestAdmin';
import type { PostPutGenericZohoValuesAdminRequest } from '../models/PostPutGenericZohoValuesAdminRequest';
import type { PutChannelLayoutRequestAdmin } from '../models/PutChannelLayoutRequestAdmin';
import type { PutChannelOrderRegionsAdminRequest } from '../models/PutChannelOrderRegionsAdminRequest';
import type { PutChannelRegionsRequestAdmin } from '../models/PutChannelRegionsRequestAdmin';
import type { PutChannelRequestAdmin } from '../models/PutChannelRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChannelsService {
    /**
     * @returns GetChannelsClientResponse OK
     * @throws ApiError
     */
    public static getChannelsClient({
        regionId,
        userAddressId,
    }: {
        regionId: number,
        userAddressId: number,
    }): CancelablePromise<GetChannelsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/channels',
            query: {
                'regionId': regionId,
                'userAddressId': userAddressId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns GetChannelsClientResponse OK
     * @throws ApiError
     */
    public static getChannelsPublicClient({
        regionId,
        language,
        currentLocationLongitude,
        currentLocationLatitude,
    }: {
        regionId: number,
        language?: Language,
        currentLocationLongitude?: number,
        currentLocationLatitude?: number,
    }): CancelablePromise<GetChannelsClientResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/channels/public',
            query: {
                'language': language,
                'regionId': regionId,
                'currentLocation.longitude': currentLocationLongitude,
                'currentLocation.latitude': currentLocationLatitude,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns ChannelAdminDto Created
     * @throws ApiError
     */
    public static postChannelAdmin({
        requestBody,
    }: {
        requestBody?: PostChannelRequestAdmin,
    }): CancelablePromise<ChannelAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/channels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannels`
     * @returns Pagination1OfChannelListedAdminDto OK
     * @throws ApiError
     */
    public static getChannelsAdmin({
        id,
        type,
        status,
        searchWord,
        regionId,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        id?: number,
        type?: ChannelType,
        status?: ChannelStatus,
        searchWord?: string,
        regionId?: number,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfChannelListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels',
            query: {
                'id': id,
                'type': type,
                'status': status,
                'searchWord': searchWord,
                'regionId': regionId,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelDetails`
     * @returns ChannelAdminDto OK
     * @throws ApiError
     */
    public static getChannelAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<ChannelAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns ChannelAdminDto OK
     * @throws ApiError
     */
    public static putChannelAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutChannelRequestAdmin,
    }): CancelablePromise<ChannelAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteChannels`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteChannelAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/channels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelDetails`
     * @returns GetChannelServiceZohoBooksAccountsAdminResponse OK
     * @throws ApiError
     */
    public static getChannelServiceGenericZohoValueServicesAdmin({
        channelId,
    }: {
        channelId: number,
    }): CancelablePromise<GetChannelServiceZohoBooksAccountsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts',
            path: {
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelDetails`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static getChannelServiceGenericZohoValuesAdmin({
        channelId,
        serviceId,
    }: {
        channelId: number,
        serviceId: number,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values',
            path: {
                'channelId': channelId,
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns GenericZohoValuesAdminDto OK
     * @throws ApiError
     */
    public static postPutChannelServiceGenericZohoValuesAdmin({
        channelId,
        serviceId,
        requestBody,
    }: {
        channelId: number,
        serviceId: number,
        requestBody?: PostPutGenericZohoValuesAdminRequest,
    }): CancelablePromise<GenericZohoValuesAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values',
            path: {
                'channelId': channelId,
                'serviceId': serviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteChannelServiceGenericZohoValuesAdmin({
        channelId,
        serviceId,
    }: {
        channelId: number,
        serviceId: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/channels/{channelId}/channel-service-zoho-accounts/{serviceId}/generic-zoho-values',
            path: {
                'channelId': channelId,
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannels`
     * @returns GetAllChannelsAdminResponse OK
     * @throws ApiError
     */
    public static getAllChannelsAdmin(): CancelablePromise<GetAllChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/all',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannelLayout`
     * @returns GetLayoutChannelsDtoResponseAdmin OK
     * @throws ApiError
     */
    public static putChannelLayoutAdmin({
        requestBody,
    }: {
        requestBody?: PutChannelLayoutRequestAdmin,
    }): CancelablePromise<GetLayoutChannelsDtoResponseAdmin> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channels/layout',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelLayout`
     * @returns GetLayoutChannelsDtoResponseAdmin OK
     * @throws ApiError
     */
    public static getChannelLayoutsAdmin({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<GetLayoutChannelsDtoResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/layout/{regionId}',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelDetails`
     * @returns GetChannelRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getChannelRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetChannelRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns GetChannelRegionsAdminResponse OK
     * @throws ApiError
     */
    public static putChannelRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutChannelRegionsRequestAdmin,
    }): CancelablePromise<GetChannelRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channels/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewChannelDetails`
     * @returns GetChannelOrderRegionsResponseAdmin OK
     * @throws ApiError
     */
    public static getChannelOrderRegionsAdmin({
        regionId,
    }: {
        regionId: number,
    }): CancelablePromise<GetChannelOrderRegionsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/channels/{regionId}/order-regions',
            path: {
                'regionId': regionId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageChannels`
     * @returns GetChannelOrderRegionsResponseAdmin OK
     * @throws ApiError
     */
    public static putChannelOrderRegionsAdmin({
        regionId,
        requestBody,
    }: {
        regionId: number,
        requestBody?: PutChannelOrderRegionsAdminRequest,
    }): CancelablePromise<GetChannelOrderRegionsResponseAdmin> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/channels/{regionId}/order-regions',
            path: {
                'regionId': regionId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
